import type { CopyRule, LaunchStatusHy, PriceStatus } from '@/api';
import LeftSidePanel from '@/components/left-side-panel';
import { LaunchStatus } from '@/components/table/table-types';
import { format } from 'date-fns';
import SummaryRow from './summary-row';

export type CopySettingsSummary = {
  validFromDate: Date;
  copyFromLabel: string;
  copyFromStatuses: PriceStatus[];
  copyToLabels: string[];
  copyToStatuses: PriceStatus[];
  productsLabels: string[];
  themesLabels: string[];
  groupsLabels: string[];
  productStatuses: LaunchStatusHy[];
  copyRule: CopyRule;
};

const COPY_RULE_LABELS: Record<CopyRule, string> = {
  CopyRrpOnly: 'RRP only',
  CopyLpOnly: 'LP only',
  CopyRrpAndLp: 'LP and RRP',
};

type CopySettingsSummaryPanelProps = {
  summary: CopySettingsSummary;
  onBack: () => void;
};

export const CopySettingsSummaryPanel = ({
  summary,
  onBack,
}: CopySettingsSummaryPanelProps) => (
  <LeftSidePanel title="Copy settings" showBackArrow onBack={onBack}>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <SummaryRow
        label="Valid from"
        value={format(summary.validFromDate, 'yyyy.MM.dd')}
      />
      <SummaryRow
        label="Copy from"
        value={summary.copyFromLabel}
        subValue={summary.copyFromStatuses.join(' & ')}
      />
      <SummaryRow
        label="Copy to"
        value={summary.copyToLabels.join(', ')}
        subValue={summary.copyToStatuses.join(' & ')}
      />
      <SummaryRow
        label="Products"
        value={
          summary.productsLabels.length > 0
            ? summary.productsLabels.join(', ')
            : 'All'
        }
      />
      <SummaryRow
        label="Theme"
        value={
          summary.themesLabels.length > 0
            ? summary.themesLabels.join(', ')
            : 'All'
        }
      />
      <SummaryRow
        label="Group"
        value={
          summary.groupsLabels.length > 0
            ? summary.groupsLabels.join(', ')
            : 'All'
        }
      />
      <SummaryRow
        label="Product Status"
        value={summary.productStatuses
          .map((status) => LaunchStatus[status])
          .join(', ')}
      />
      <SummaryRow
        label="Copy rule"
        value={COPY_RULE_LABELS[summary.copyRule]}
      />
    </div>
  </LeftSidePanel>
);
